import React from "react";
import { Location } from "history";
import { inject, observer } from "mobx-react";
import { Redirect } from "react-router-dom";
import styled from "@emotion/styled";
import { Space } from "antd";

import AuthStore from "app/AuthStore";
import Logo from "components/Logo";
import { PageLoading, Helmet } from "components/Layout";

import LoginForm from "./LoginForm";

const LandingPage = styled("div")`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

const Title = styled("h2")``;

interface LandingProps {
  authStore?: AuthStore;
  location: Location;
}

const Landing = inject("authStore")(
  observer(({ authStore, location }: LandingProps) => {
    if (authStore!.isLoggedIn) {
      let redirect = "";
      if (window.URLSearchParams) {
        redirect = new URLSearchParams(location.search).get("redirect") || "";
      } else {
        const params = (location.search || "").replace("?", "").split("&");
        redirect = (
          params.find((x) => x.startsWith("redirect=")) || ""
        ).replace("redirect=", "");
      }
      return <Redirect to={decodeURIComponent(redirect) || "/"} />;
    }

    if (authStore!.isLoggedIn === undefined) {
      return <PageLoading />;
    }

    return (
      <LandingPage>
        <Helmet title="Login" />
        <Space direction="vertical" align="center" size="large">
          <Logo width="80px" />
          <Title>Lawfully Intra Web</Title>
        </Space>
        <LoginForm />
      </LandingPage>
    );
  }),
);

export default Landing;
